export default {"src":"/_next/static/media/summary-icon.b19ec45a.svg","height":13,"width":13};